<ng-template #content let-modal let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">System Setting </h4>

    <button [disabled]=" isSending " type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 table-title">
          <label>System Default Roles</label>
        </div>
        <div class="col-md-6 table-actions">
          <button type="button" class="btn btn-primary btn-square btn-sm pull-right"
                  [disabled]="isSending || isCreating || isLoading || isEditing"
                  (click)="onAddNewRole()">
            NEW ROLE
          </button>
        </div>
      </div>

      <div class="row">

        <div class="col table-system-roles-container">

          <div  *ngIf="isLoading" class="modal-loading">
            <i class="fas fa-spinner  fa-spin fa-lg  icons"> </i>
          </div>

          <ccc-table [config]="roleTableConfig" *ngIf="!isLoading">
            <thead>
              <tr class="headers">
                <th class="align-middle text-center table-role-name-header">
                  PERMISSIONS
                </th>
                <th class="align-middle text-center table-dynamic-header" *ngFor="let role of roles">
                  <label *ngIf="!role.isEditingRole">{{role.name}}</label>

                  <ccc-validated-input-field class="form-control-sm"
                                             [field]="role.name"
                                             fieldName="name"
                                             *ngIf="role.isEditingRole"
                                             [errors]="(rolesErrors[role.id] && rolesErrors[role.id]['name']) || []"
                                             (changesMade)="onChangeRoleName(role, $event)">
                  </ccc-validated-input-field>

                  <label class="edit-column" (click)="onEditRole(role)" *ngIf="!role.isEditingRole && !isEditing && !isCreating" >edit</label>
                </th>
              </tr>
            </thead>
            <thead >
              <th class="action-header"></th>
              <th class="align-middle text-center action-header" *ngFor="let role of roles">
                <div class="show-templates-container">
                  <ui-switch name="publish-role-switch"
                             id="publish-role-switch"
                             class="publish-role-switch"
                             color="#412986"
                             size="small"
                             [checked]="role.published"
                             (change)="onChangeRolePublished($event, role)"
                             [disabled]="!role.isEditingRole">
                  </ui-switch>
                  <label for="publish-role-switch">Publish</label>
                </div>
              </th>
           </thead>

            <tbody class="permissions-table-body">
              <ng-container>
                <tr *ngFor="let perrmission of permissions">
                  <td>
                    <label class="role-name"> <i class="fas fas fa-question-circle"></i> {{perrmission.name}}</label>
                  </td>
                  <td class="align-middle text-center" *ngFor="let role of roles">
                    <input type="checkbox"
                           [checked]="markRolePermission(perrmission, role.permissions)"
                           (change)="onCheckRolePermission($event, role, perrmission)"
                           *ngIf="role.isEditingRole">

                    <i class="fas fas fa-check" *ngIf="markRolePermission(perrmission, role.permissions) && !role.isEditingRole"></i>

                  </td>
                </tr>
              </ng-container>
            </tbody>

          </ccc-table>
        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button type="button"
            class="btn btn-primary btn-square btn-sm"
            (click)="saveRolesChanges()"
            [disabled]="isSending || !hasRoleChanges">Save</button>

    <button [disabled]="isSending"
            type="button" class="btn btn-square btn-sm"
            (click)="onCancel()">Cancel</button>
  </div>

</ng-template>

<ccc-confirm-modal #modalSave (confirmAction)="onCloseConfirmModal($event)"></ccc-confirm-modal>
<ccc-confirm-modal #modalCancel
                   (confirmAction)="onCloseConfirmModal($event)"
                   confirmMessage="Are you sure you want cancel current changes?"></ccc-confirm-modal>
